"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubstituteAvailabilityApiResponseSchema = exports.substituteAvailabilityEntrySchema = exports.getSubstituteAvailabilityApiPayloadSchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
exports.getSubstituteAvailabilityApiPayloadSchema = zod_1.z.object({
    rangeStart: zod_1.z.string().date(),
    rangeEnd: zod_1.z.string().date(),
});
exports.substituteAvailabilityEntrySchema = zod_1.z.object({
    date: zod_1.z.string(),
    period: zod_1.z.enum(event_schema_1.periodsOfTheDayWithoutAllday),
});
exports.getSubstituteAvailabilityApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.substituteAvailabilityEntrySchema),
});
